<template>
  <div class="contact-info">
    <div class="picture-part">
      <div class="img-width">
        <v-dialog
          v-model="dialog2"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          width="100%"
        >
          <template v-slot:activator="{ on, attrs }">
            <button
              class="btn open-image-btn"
              v-bind="attrs"
              v-on="on"
            >
              <img :src="user_info.ThumbPath" />


            </button>
          </template>

          <v-card class="edit-picture blue-border">
            <v-toolbar
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="dialog2 = false"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <!--                <v-toolbar-title>گالری</v-toolbar-title>-->
              <v-spacer></v-spacer>

            </v-toolbar>

            <v-card-text>

              <VueSlickCarousel :arrows="true" :dots="false">
                <div v-for="item in photos" class="full-screen-photos">
                  <img :src="item.ImageUrl" />

                </div>

              </VueSlickCarousel>
            </v-card-text>


          </v-card>
        </v-dialog>
      </div>
      <div class="name-width" v-if="group_flag == false">
        {{ user_info.Name }}
      </div>
      <div class="name-width" v-if="group_flag == true">
        {{ user_info.GroupName }}
      </div>
      <div class="add-width">
        <div v-on:click="goToDetail()">
          <v-icon>
            mdi-email-outline
          </v-icon>
        </div>

      </div>
    </div>

    <div class="user-code">
      <label>
        شناسه کاربری
      </label>
      <p v-if="group_flag == false">
        {{ user_info.UserCode}}
      </p>
      <p v-if="group_flag == true">
        {{ user_info.GroupCode}}
      </p>
    </div>
    <div class="notification">
      <div class="row">
        <div class="col-6">
          اطلاع رسانی
        </div>
        <div class="col-6">
          <v-switch
            v-model="switch1"
            flat
          ></v-switch>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  data(){
    return {
      user_info :'',
      items: '',
      switch1: true,
      dialog2: false,
      photos: '',
      UserId: '',
      group_flag: false,
      silent_list: [],
    }
  },
  components: { VueSlickCarousel },
  watch: {
    switch1: function (val) {

      if(val == false) {
        this.add_silent("add");

      }

    }
  },
  methods: {
    add_silent(txt) {
      if( txt == "add") {
        console.log("an")
        var thing = [];
        if(localStorage.getItem("silent3") == null){
          var thing = [];
          thing.push(this.items.UserOrGroupId);
          localStorage.setItem("silent3", JSON.stringify(thing));
        }
        else {
          thing = localStorage.getItem("silent3");
          thing = JSON.parse(thing);
          var filter= false;
          for(var i=0; i<thing.length; i++){
            if(thing[i] == this.items.UserOrGroupId){
              filter = true;
            }
          }
          if(filter == false){
            thing.push(this.items.UserOrGroupId);
            localStorage.setItem("silent3", JSON.stringify(thing));
          }

          // console.log("thingggggggg ", thing)
        }


        // console.log("thins ", thing)
      }
    },
    goToDetail(item) {
      // console.log("iteem", )
      const last_chat_detail = {
        "RecType": this.items.RecType,
        "UserOrGroupId" : this.items.UserOrGroupId,
      }
      localStorage.setItem("lastChat", JSON.stringify(last_chat_detail))
      this.$router.push({name: 'مکالمه', params: {}})
    },
    GetUserImages() {
      const send_data = {
        "UserId":this.items.UserOrGroupId,
        "RecType": this.items.RecType,
      };
      var self = this;
      this.axios.post('/GetUserImages' , send_data,{})
        .then(response => {
          if(response.data.error == 0) {
            console.log("user info" , response.data.imgs)
            self.photos = response.data.imgs;
            // self.user_info = response.data.userInfo;
          }

        }).catch(e => {

      })
    },
    getGroupInfo() {
      console.log("get group info")
      const send_data = {
        "UserId":this.UserId,
        "GroupId":this.items.UserOrGroupId
      };
      var self = this;
      this.axios.post('/GetGroupInfo' , send_data,{})
        .then(response => {
          if(response.data.error == 0) {
            // console.log("user info" , response.data.userInfo)
            self.user_info = response.data.userInfo;
          }

        }).catch(e => {

      })
    },
    getUserInfo(){
      const send_data = {
        "UserId":this.items.UserOrGroupId
      };
      var self = this;
      this.axios.post('/GetUserInfo' , send_data,{})
        .then(response => {
          if(response.data.error == 0) {
            console.log("user info" , response.data.userInfo)
            self.user_info = response.data.userInfo;
          }

        }).catch(e => {

      })
    },
  },
  mounted() {
    var user_data = JSON.parse(localStorage.getItem("profile"));

    this.UserId = user_data.UserId
    this.items = JSON.parse(localStorage.getItem("lastChat"));
    // console.log("lastChat", this.items)
    if(this.items.RecType == 0){
      this.getUserInfo();
      this.group_flag = false;
    }
    else {
      this.getGroupInfo();
      this.group_flag = true;
    }
    this.GetUserImages();
    // this.getUserInfo();
    // localStorage.getItem("LastUserInfo")

  }

}
</script>
